import { clientCredentials } from './graphql/queries';
import axios from 'axios';

export const REGX = {
	url: /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;()]*[-A-Z0-9+&@#/%=~_|?()])/ig, //@see https://stackoverflow.com/questions/1500260/detect-urls-in-text-with-javascript (added ()?)
	jwt: /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/
};

export function getPayload(token) {
	if(!REGX.jwt.test(token)) throw new Error('invalid token');
	return JSON.parse(atob(token.split('.')[1]));
}

export function registerToken(client) {

	const token = localStorage.getItem('token');
	if(!token) return false;
	const payload = getPayload(token);

	if(payload.exp*1000 < Date.now() ) {
		resetToken(client);
		return -1;
	}
	client.writeQuery({
		query: clientCredentials,
		data: {
			clientCredentials: {
				__typename: 'credentials',
				id: payload.id,
				name: payload.name,
				avatar: payload.avatar
			}
		}
	});

	return payload;
}

//aka logout
export function resetToken(client) {
	//client.resetStore(); //@TODO fix resetStore
	client.writeQuery({
		query: clientCredentials,
		data: {
			clientCredentials: {
				__typename: 'credentials',
				id: null,
				name: 'anonymous',
				avatar: 'vimeo.jpg'
			}
		}
	});
	localStorage.removeItem('token');
}


export function query2State(data) {

	let newObj = {};
	for(let key in data) {
		newObj[key] = data[key] || '';
	}
	return newObj;
}

export function formatDate(dateIn, withTime) {
	let date = '';
    if(dateIn) {
      let dateObj = new Date(dateIn);
      date = dateObj.getDate() + '.' + (dateObj.getMonth()+1) + '.' + String(dateObj.getFullYear()).substr(2);
      if(withTime) date += ' ' + formatTime(dateIn);
    }
    return date;
}

export function formatTime(dateIn) {
	let date = '';
    if(dateIn) {
	  let dateObj = new Date(dateIn);
	  let dateMins = String(dateObj.getMinutes());
	  if(dateMins.length === 1) dateMins = '0'+ dateMins;
      date = dateObj.getHours() + ':' + dateMins;
    }
    return date;
}

export function formatDateHTML(date) {

	if(!date) return '';
	if(typeof date === 'string') {
		return date.split('T')[0];
	} else if(typeof date === 'object') {
		return date.toISOString().split('T')[0];
	} else {
		return '';
	}
}


export function formatFileSize(bytes) {
	var i = -1;
    var units = ['KB', 'MB', 'GB'];
    do {
        bytes = bytes / 1024;
        i++;
    } while (bytes > 1024);

    return `${bytes.toFixed(2)} ${units[i]}`;
}

export function getFileKey(file) {
	return file.name + '-' + file.size + '-' + file.lastModified;
}

export function escapeHTML(unsafeText) {
    const div = document.createElement('div');
    div.innerText = unsafeText;
    return div.innerHTML;
}

/**
 * @see https://stackoverflow.com/questions/5069464/replace-multiple-strings-at-once/5069776
 */
export function replaceBulk( str, findArray, replaceArray ){
	if(!findArray.length) return str;
	//console.log('replaceBulk', str, findArray, replaceArray);
	var i, regex = [], map = {}; 
	for( i=0; i<findArray.length; i++ ){ 
		regex.push( findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g,'\\$1') );
		map[findArray[i]] = replaceArray[i]; 
	}
	regex = regex.join('|');
	str = str.replace( new RegExp( regex, 'g' ), function(matched) {
		return map[matched];
	});
	return str;
}

export function getServerURL() {
	return process.env.NODE_ENV==='production' ? 'https://trashnet.de:3001' : 'http://localhost:3001';
}

export function postUpload({files, channel, parent}) {

	//console.log('posting le upload ...', files, parent);
	const token = localStorage.getItem('token'); 
	const url = process.env.NODE_ENV==='production' ? 'https://trashnet.de:3001/upload' : 'http://localhost:3001/upload';

	
	const formData = new FormData();
	formData.append('file', files[0]);
	if(channel) formData.append('channel', channel);
	if(parent) formData.append('parent', parent);

	return axios
		.post(url, formData, {
			headers: {authorization: `Bearer ${token}`}
		})
		.then(function (response) {
			//console.log('response ...', response.data);
			return response;
		})
		.catch(error => {
			if(error.response) {
				console.log('Upload Error', error.response.status, error.response.statusText);
				if(error.response.config) 
					console.log(error.response.config.method.toUpperCase(), 
						error.response.config.url, error.response.config.params)
			}
		});
}

/**
 * creates "random" 8 letter id
 */
export function getFuid() {
	return (+new Date).toString(36).slice(-8);
}


export function getRandomAffordance() {
	const affordances = [
		'Was beschäftigt dich?', 
		'Was gibt\'s Neues?',
		'Was geht?',
		'WTF?',
		'¿Qué pasa?',
		'Was denkst du?',
		'Was meinste?'
	];
	return affordances[ Math.floor(Math.random()*affordances.length) ];
}


// WEBPACK FOOTER //
// ./src/util.js